module.exports = __webpack_public_path__ + "frontend-assets/img/info_icon.5af37d77.png";